exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "hr {\r\n    margin-top: 10px  !important;\r\n    margin-bottom: 10px  !important;\r\n    border: 0;\r\n    border-top: 1px solid #ddd  !important;\r\n}\r\n.input-group{\r\n    border-spacing: 0; border-collapse: separate;\r\n}\r\n.input-group-addon{\r\n    padding: 0 12px !important;\r\n}\r\n.bg-td{\r\n    background-color: #f2eded;\r\n    padding: 5px;\r\n}\r\n.search-line-height{\r\n    line-height: 0.71 !important;\r\n}\r\nbutton.search-line-height{\r\n    border:1px solid darkgrey !important;\r\n    background-color: #e6e6e6 !important;\r\n}\r\nbutton.search-line-height:hover{\r\n    border:1px solid darkgrey !important;\r\n    background-color: #d4d4d4 !important;\r\n}\r\n.ui-datepicker td.ui-state-disabled>span{background:#c30;}\r\n.ui-datepicker td.ui-state-disabled{opacity:100;}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/views/pages/master/op/announcement/announcement-details/announcement-details.css
// module id = 784
// module chunks = 7